import { Hammer, Save, Download } from 'lucide-react';
import { useProjectStore } from '../../store/projectStore';

export function Header() {
  const hasUnsavedChanges = useProjectStore((state) => state.hasUnsavedChanges);
  const exportProject = useProjectStore((state) => state.exportProject);

  return (
    <header className="h-14 bg-slate-900 text-white flex items-center justify-between px-4 shadow-md shrink-0">
      <div className="flex items-center gap-2">
        <Hammer className="text-blue-400" size={22} />
        <h1 className="text-lg font-bold tracking-tight">PromptForge</h1>
        <span className="hidden sm:inline text-xs text-slate-400 ml-2">提示詞鍛造器</span>
      </div>
      <div className="flex items-center gap-2">
        {hasUnsavedChanges && (
          <span className="hidden md:inline text-xs text-slate-400">有未保存變更</span>
        )}
        <button
          type="button"
          onClick={exportProject}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md bg-blue-600 hover:bg-blue-700 text-white transition-colors"
        >
          <Download size={14} />
          <span className="hidden sm:inline">導出全部</span>
        </button>
      </div>
    </header>
  );
}
